<template>
  <div class="coach-court-list profile-court-list">
    <ul class="nav">
      <li>
        <router-link
          v-bind:class="{
            active: currentPath.includes('appointment-details'),
          }"
          to="/coaches/coach-profile"
          >Profile</router-link
        >
      </li>
      <li><router-link to="/coaches/setting-lesson">Lesson</router-link></li>
      <li><router-link to="/coaches/setting-availability">Availability</router-link></li>
      <li><router-link to="/coaches/setting-password">Change Password</router-link></li>
      <li>
        <router-link to="/coaches/profile-othersetting">Other Settings</router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentPath: this.$route.path,
    };
  },
};
</script>
